const ROOTS_DEMO = '/demo';
const ROOTS_EBOOKS = '/ebooks';
const ROOTS_CASE_STUDIES = '/customers';
const ROOTS_INDUSTRIES = '/industries';
const ROOTS_INTEGRATIONS = '/integrations';

export const PATH_FAQ = {
  ROOT: '/faq',
};

export const PATH_DEMO = {
  ROOT: ROOTS_DEMO,
  CUSTOMER_DEMO: '/customer/demo',
  AGENT_DEMO: '/cosupport-agent/demo',
  BI_DEMO: '/cosupport-bi/demo',
  COSUPPORT_CUSTOMER_DEMO: '/cosupport-customer/demo',
  SCHEDULE_DEMO: '/schedule-a-demo',
};

export const PATH_INTEGRATION = {
  ROOT: ROOTS_INTEGRATIONS,
  INTEGRATION_ZENDESK: `${ROOTS_INTEGRATIONS}/zendesk`,
  INTEGRATION_FRESHDESK: `${ROOTS_INTEGRATIONS}/freshdesk`,
  INTEGRATION_SLACK: `${ROOTS_INTEGRATIONS}/slack`,
  INTEGRATION_ZOHO: `${ROOTS_INTEGRATIONS}/zoho`,
};

export const PATH_INDUSTRIES = {
  ROOT: ROOTS_INDUSTRIES,
  INDUSTRIES_AI_ECOMMERCE_ASSISTANT: `${ROOTS_INDUSTRIES}/ai-ecommerce-assistant`,
  INDUSTRIES_SAAS_TECHNOLOGY: '#',
  INDUSTRIES_FINANCE_BANKING: '#',
};

export const PATH_CASE_STUDIES = {
  ROOT: ROOTS_CASE_STUDIES,
  SOFTORINO: `${ROOTS_CASE_STUDIES}/softorino`,
  SHELTERLUV: `${ROOTS_CASE_STUDIES}/shelterluv`,
  ECOMMERCE: `${ROOTS_CASE_STUDIES}/ai-in-ecommerce-case-study`,
  COCOATECH: `${ROOTS_CASE_STUDIES}/cocoatech`,
};

export const PATH_EBOOKS = {
  ROOT: ROOTS_EBOOKS,
  AI_CUSTOMER_STRATEGY: `${ROOTS_EBOOKS}/ai-customer-support-strategy`,
};
export const PATH_ABOUT = {
  ROOT: '/about',
};
export const PATH_AGENT = {
  ROOT: '/cosupport-agent',
};
export const PATH_BI = {
  ROOT: '/cosupport-bi',
};
export const PATH_CUSTOMER = {
  ROOT: '/cosupport-customer',
};
export const PRODUCT_DEMO = {
  ROOT: '/product-demo',
  AGENT: '/product-demo/cosupport-agent',
  BI: '/product-demo/cosupport-bi',
  AGENT_OLD: '/cosupport-agent/product-demo',
};

export const PATH_ARTICLES = {
  ROOT: '/articles',
  AI_WINS: '/articles/klarna-ai-wins-big',
  WORLD_AWARDS: '/articles/cosupport-wins-ai-world-series-award-2024',
  PATENT: '/articles/cosupport-ai-patent',
  NO_HALLUCINATIONS: '/articles/ai-support-no-hallucinations-advanced-customer-service-tech',
};
export const PATH_PRIVACY = {
  ROOT: '/privacy',
  DPA: '/dpa',
  TERMS_OF_WEBSITE: '/terms-of-website',
  TERMS_OF_SERVICES: '/terms-of-services',
  SUB_PROCESSORS_LIST: '/sub-processors-list',
  RESELLER_TERMS: '/reseller-terms-of-services',
};
export const PATH_SUCCESS = {
  ROOT: '/success',
};
export const PATH_AUTHORS = {
  ROOT: '/authors',
};
export const PATH_TAGS = {
  ROOT: '/tags',
};
export const PATH_BUSINESS_HREF = {
  ROOT: '/businessHREF',
};
